// extracted by mini-css-extract-plugin
module.exports = {"item":"OrderDetailDropdown_item__Y-V1p","dropdown-button":"OrderDetailDropdown_dropdown-button__1cUzi"};